import * as React from 'react';

export class TruncateComponentReact extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        this.state = {
            value: null,
            isLoggedIn: false,
            truncateContent: props.truncateContent,
            truncateHeightThreshold: props.truncateHeightThreshold,
            showMoreText: props.showMoreText || undefined,
            showLessText: props.showLessText || undefined,
            containerId: props.containerId || undefined,
            Truncated: false,
            TruncateHeight: undefined,
            TruncateOverlayHeight: undefined,
            truncateClickedByUser:false,
        };
        this.ToggleTruncate_CLICK = this.ToggleTruncate_CLICK.bind(this);
    }

    divElement: HTMLDivElement | undefined;

    ShowTruncate: boolean;
    Truncated: boolean;
    TruncateHeight: any;
    TruncateOverlayHeight: any;
    truncateHeightThreshold: number = 200;

    
    UNSAFE_componentWillReceiveProps(nextProps){
        this.setState({
            truncateContent: nextProps.truncateContent,
            Truncated: false,
            TruncateHeight: 'auto',
            ShowTruncate: false,
            truncateClickedByUser:false,
        });
    }

    componentDidUpdate(){
        if(!this.state.truncateClickedByUser){
            const height = this.divElement.clientHeight;
            var truncateHeightThreshold = this.props.truncateHeightThreshold || this.truncateHeightThreshold;
            if ((window as any).$GlobalMiddleware.getWindowWidth() > 1024 && height > truncateHeightThreshold) {
                this.AddTruncate();
            }
        }

    }
    AddTruncate() {
        this.ShowTruncate = true;
        this.Truncated = true;
        var truncateHeightThreshold = this.props.truncateHeightThreshold || this.truncateHeightThreshold;
        this.TruncateHeight = truncateHeightThreshold + 'px';
        this.TruncateOverlayHeight = truncateHeightThreshold * .4 + 'px';
        this.setState({
            Truncated: true,
            TruncateHeight: truncateHeightThreshold + 'px',
            ShowTruncate: this.ShowTruncate,
            TruncateOverlayHeight: truncateHeightThreshold * .4 + 'px'
        });

    }

    RemoveTruncate() {
        this.ShowTruncate = false;
        this.Truncated = false;
        this.TruncateHeight = 'auto';
        this.setState({
            Truncated: false,
            TruncateHeight: 'auto',
            ShowTruncate: false,
            TruncateOverlayHeight: this.TruncateOverlayHeight
        });
    }


    render() {
        if (this.state.truncateContent) {
            return this.getTruncateContent();
        }
        return this.getEmptyContnet();
    }


    getTruncateContent() {
        return <><div className={!this.state.Truncated ? 'truncate__content' : 'truncate__content truncate'}
            style={!this.state.Truncated ? { height: 'auto' } : { height: this.state.TruncateHeight }}
            ref={(divElement) => this.divElement = divElement}>

            <div className={this.state.ShowTruncate ? 'truncate__wrapper' : ' '}>
                <span>
                    {this.state.truncateContent}
                </span>

            </div>

            {(this.state.ShowTruncate && 
                <div  className="truncate__overlay" style={{height: this.state.TruncateOverlayHeight}}></div>
                
                )}
        </div>
        {this.getShowMoreShowLessButtons()}
        </>
    }

    getShowMoreShowLessButtons(){
        if(this.state.ShowTruncate){
            if(this.state.Truncated){
                return <a className="truncate-trigger" onClick={() => this.ToggleTruncate_CLICK()}>{this.state.showMoreText}</a>
            }else{
                return <a className="truncate-trigger" onClick={() => this.ToggleTruncate_CLICK()}>{this.state.showLessText}</a>
            }
        }
        return <></>;
    }


    ToggleTruncate_CLICK() {

        this.Truncated = !this.Truncated;
        if (this.Truncated) {
            //let container = (document as any).getElementById(this.containerId);
            let pos = this.divElement.getBoundingClientRect();
            if (pageYOffset > pos.top + pageYOffset) {
                this.divElement.scrollIntoView();
            }
        }
        this.setState({
            Truncated: this.Truncated,
            truncateClickedByUser:true,
        });
        return false;
    }

    //  divStyle = {
    //     color: 'blue',
    //     backgroundImage: 'url(' + imgUrl + ')',
    //   };


    getEmptyContnet() {
        return <></>;
    }
}